/* eslint-disable */
// @flow

export let swRegistration = null;
export let isSubscribed = false;
export let promptEvent = null;

export const beforeinstallprompt = (e: any) => {
  e.prompt();
};

export const addBeforeInstallPrompt = () => {
  window.addEventListener('beforeinstallprompt', beforeinstallprompt);
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('service-worker.js')
      .then(successRegister)
      .catch((e: any) => {
        console.error('Error during service worker registration:', e);
      });
  }
};

export const onStateChange = (installingWorker: any) => {
  switch (installingWorker.state) {
    case 'installed':
      if (navigator.serviceWorker.controller) {
        console.log('New or updated content is available.');
      } else {
        console.log('Content is now available offline!');
      }
      break;
    case 'redundant':
      console.info('The installing service worker became redundant.');
      break;
  }
};

export const onUpdateFound = (reg: any) => {
  const installingWorker = reg.installing;
  installingWorker.onstatechange = () => onStateChange(installingWorker);
};

export const successRegister = (reg: any) => {
  swRegistration = reg;
  reg.onupdatefound = () => onUpdateFound(reg);
};
